import axios from 'axios';

const newsService = {
  /**
   * 获取新闻列表
   * @param {Object} params - 查询参数
   * @param {number} params.page - 当前页码
   * @param {number} params.limit - 每页数量
   * @param {string} params.category - 新闻分类
   * @returns {Promise} 返回新闻列表数据
   */
  getNewsList(params = {}) {
    return axios.get('/api/news', {
      params,
      timeout: 5000
    });
  },

  /**
   * 获取单个新闻详情
   * @param {number} id - 新闻ID
   * @returns {Promise} 返回新闻详情
   */
  getNewsById(id) {
    return axios.get(`/api/news/${id}`, {
      timeout: 5000
    });
  },

  /**
   * 获取上一篇和下一篇新闻
   * @param {number} id - 当前新闻ID
   * @returns {Promise} 返回上一篇和下一篇新闻信息
   */
  getAdjacentNews(id) {
    return axios.get(`/api/news/${id}/adjacent`, {
      timeout: 5000
    });
  },

  /**
   * 增加新闻浏览量（用于外部链接点击）
   * @param {number} id - 新闻ID
   * @returns {Promise} 返回操作结果
   */
  incrementViews(id) {
    return axios.post(`/api/news/${id}/increment-views`, {}, {
      timeout: 5000
    });
  }
};

export default newsService; 